export type FeedStatusView = {
  status: string;
  feedSyncedAt: string | null;
  lastAttemptAt: string | null;
  consecutiveFailures: number;
  lastError: string | null;
};

function calendarDay(value: string | null): string {
  if (!value) return "never";
  const parsed = Date.parse(value);
  if (Number.isNaN(parsed)) return "never";
  return new Date(parsed).toISOString().slice(0, 10);
}

/** Same cap the WordPress coverage sentence uses for a stale-feed error. */
export const FEED_STATUS_ERROR_LIMIT = 200;

function indexError(value: string | null): string {
  if (!value) return "";
  const oneLine = value.replace(/\s+/g, " ").trim();
  if (!oneLine) return "";
  return ` ${oneLine.slice(0, FEED_STATUS_ERROR_LIMIT)}`;
}

/** One line on the site audits index. The stored error is shortened the same way as the report. */
export function formatFeedStatusLine(state: FeedStatusView): string {
  return `Vulnerability feed: ${state.status}. Last synced ${calendarDay(state.feedSyncedAt)}. Last attempt ${calendarDay(state.lastAttemptAt)}.${indexError(state.lastError)}`;
}
